import '../../V1/Javascripts/elements/navigation--viewport';
import '../../V1/Javascripts/elements/navigation--desktop';
import '../../V1/Javascripts/hissu/top-bar';
import '../../V1/Javascripts/elements/accordion';
import '../../V1/Javascripts/elements/buttons';
import '../../V1/Javascripts/elements/contact-box--reset';
import '../../V1/Javascripts/elements/slider';
import '../../V1/Javascripts/elements/slider-l10n';
import '../../V1/Javascripts/elements/line-clamp';
import '../../V1/Javascripts/elements/singleselect';
import '../../V1/Javascripts/elements/datepicker';
import '../../V1/Javascripts/elements/quicksearch';
import '../../V1/Javascripts/elements/focusarea';
import '../../V1/Javascripts/elements/review';
import '../../V1/Javascripts/elements/form-scroll-into-view';
import '../../V1/Javascripts/elements/form-validation';
import '../../V1/Javascripts/elements/typo3-messages';
import '../../V1/Javascripts/elements/navigation--click';
import '../../V1/Javascripts/elements/video-autoplay';

/* V1.5 elements */
import './elements/video-autoplay';

import { initMainNavBurger } from './elements/_navigation-burger';
import { initMainNavOverlay } from './elements/_navigation-overlay';
import { initMainNav } from './elements/_navigation-control';

function initCustomHissuV15Scripts() {
  initMainNavBurger();
  initMainNavOverlay();
  initMainNav();
}

if (document.readyState !== 'loading') {
  setTimeout(initCustomHissuV15Scripts);
} else {
  document.addEventListener('DOMContentLoaded', initCustomHissuV15Scripts, { once: true });
}
